import { CmsObjectWithDefault } from '@components/Cms/types';

export type PhoneAssociationPanelCmsKey = 'titleHeader' | 'closeButton';

export const PhoneAssociationPanelCmsWithDefault: CmsObjectWithDefault<PhoneAssociationPanelCmsKey> = {
    titleHeader: {
        cmsId: 258876,
        defaultTranslation: 'Verify your phone number',
    },
    closeButton: {
        cmsId: 155202,
        defaultTranslation: 'Close',
    },
};
